export const clearLocalStorage = () => {
  for (let i = localStorage.length; i >= 0; i--) {
    const key = localStorage.key(i);

    if (key && key != "appVersion") {
      localStorage.removeItem(key);
    }
  }
};